import { Preferences } from '@interfaces/models/preferences';

export enum ProductFeedSource {
  PDP = 'PDP',
  HeroPDP = 'HeroPDP',
}

export interface ProductFeedPayload {
  locale: {
    country: Preferences['country'];
    language: Preferences['language'];
    currency: Preferences['currency'];
  };
  pagination?: {
    limit: number;
    offset: number;
  };
  productID: number;
  source?: ProductFeedSource;
}
